export const footer = {
  time: "from 9:00 to 21:00 (no days off)",
  phone: "+7 747 557 74 64",
  address_city: "Kazakhstan, Almaty",
  address: "168a Zhetoksan Street",
  faqs: "FAQs",
  list: "equipment list",
};
